import globals from "imports/globals";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

const component = (function () {
    $(window).on("load", function () {
        /**
         * Zoom In
         */
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.create({
            trigger: $("#zoom-out")[0],
            start: "top center-=20%",
            endTrigger: "html",
            end: "bottom top",
            onToggle: (self) => {
                if (self.isActive) {
                    var color = $(self.trigger).attr("data-theme-to");
                    $("html").attr("data-theme", color);
                    $(self.trigger).find(".zoom-out").addClass("on");
                } else {
                    $("html").attr("data-theme", "");
                    $(self.trigger).find(".zoom-out").removeClass("on");
                }
            },
            // markers: true,
        });

        $(".masonry-grid").each(function () {
            ScrollTrigger.create({
                trigger: $(this)[0],
                start: "top bottom-=10%",
                endTrigger: "html",
                end: "bottom top",
                onToggle: (self) => {
                    if (self.isActive) {
                        $(self.trigger)
                            .find(".masonry-grid-cell")
                            .each(function (_i, _el) {
                                setTimeout(function () {
                                    $(_el).addClass("on");
                                }, _i * 100);
                            });
                    } else {
                        $(self.trigger).find(".masonry-grid-cell").removeClass("on");
                    }
                },
                // markers: true,
            });
        });
    });
})();

export default component;
